//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import treeMenu from "@/components/treeMenu/index.vue";
import { favorOrRecall as _favorOrRecall } from "@/api/serveCenter/serveCenter";
import { homeChargePage, homeChargeDeptList, homeChargeDeptTree, homeChargeServeVoList } from "@/api/homeCharge/homeCharge";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
export default {
  name: "AccrualBasis",
  components: {
    treeMenu: treeMenu
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      serveList: [],
      serveName: "",
      curServeId: null,
      searchDeptId: "",
      active: "dept",
      deptList: [],
      list: [],
      leftLoading: false,
      loading: false,
      paramSearch: {
        current: 1,
        size: 10,
        mDeptId: "",
        serveId: "",
        deptId: ""
      },
      total: 0
    };
  },
  computed: {
    serveListFilter: function serveListFilter() {
      var _this = this;

      if (this.serveName) {
        return this.serveList.filter(function (i) {
          return i.serveName.indexOf(_this.serveName) > -1;
        });
      } else {
        return this.serveList;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.homeChargeServeVoListFn();
    this.getHomeChargeDeptList("", "");
  },
  destroyed: function destroyed() {},
  methods: {
    favorOrRecall: function favorOrRecall(item) {
      var _this2 = this;

      var params = {
        isFavor: item.tagType ? false : true,
        serveId: item.serveId
      };
      this.loading = true;

      _favorOrRecall(params).then(function (_ref) {
        var data = _ref.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.$message.success(!item.tagType ? "收藏成功!" : "取消收藏成功!");

          item.tagType = item.tagType ? null : true;
        } else {
          _this2.$message.warning(data.msg || "操作失败!");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    HandleApply: function HandleApply(processDefId) {
      var _this3 = this;

      bpmnStartProcess({
        processDefId: processDefId
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          window.open(data.data.url);
        } else {
          _this3.$message.warning(data.msg || "流程系统业务忙，请刷新或者重新操作");
        }
      }).catch(function (err) {
        _this3.$message.error("服务异常");
      });
    },
    goHref: function goHref(id, name) {
      var routeData = this.$router.resolve({
        name: name,
        query: {
          id: id
        }
      });
      window.open(routeData.href);
    },
    nodeClick: function nodeClick(obj) {
      this.getHomeChargeDeptList(obj.id, "");
    },
    getHomeChargeDeptList: function getHomeChargeDeptList(deptId, serveId) {
      var _this4 = this;

      var params = {
        deptId: deptId,
        serveId: serveId
      };
      homeChargeDeptList(params).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.deptList = data.data || [];
          _this4.searchDeptId = "";
          _this4.paramSearch = {
            current: 1,
            size: 10,
            mDeptId: _this4.searchDeptId,
            serveId: serveId,
            deptId: deptId
          }, _this4.getListFn();
        }
      }).catch(function (err) {});
    },
    // 获取查询列表
    homeChargeServeVoListFn: function homeChargeServeVoListFn() {
      var _this5 = this;

      this.leftLoading = true;
      homeChargeServeVoList().then(function (_ref4) {
        var data = _ref4.data;
        _this5.leftLoading = false;

        if (data.code == 0) {
          _this5.serveList = data.data || [];
        }
      }).catch(function () {
        _this5.leftLoading = false;
      });
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this6 = this;

      this.loading = true;
      homeChargePage(this.paramSearch).then(function (_ref5) {
        var data = _ref5.data;
        _this6.loading = false;

        if (data.code == 0) {
          _this6.list = data.data.records || [];
          _this6.total = data.data.total;
        }
      }).catch(function () {
        _this6.loading = false;
      });
    },
    changeTab: function changeTab(value) {
      this.active = value;

      if (value == "serve") {} else {
        this.curServeId = null;
      }

      this.getHomeChargeDeptList("", "");
    },
    changeId: function changeId(id) {
      this.curServeId = id;
      this.getHomeChargeDeptList("", id);
    },
    changeDeptId: function changeDeptId(id) {
      if (this.searchDeptId == id) {
        this.searchDeptId = "";
      } else {
        this.searchDeptId = id;
      }

      this.paramSearch.size = 10;
      this.paramSearch.current = 1;
      this.paramSearch.mDeptId = this.searchDeptId;
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};